module.exports = __webpack_public_path__ + "static/media/od_3.2a6cee0e.jpg";